import { SimpleNavigation, SimpleRefinementItem } from '@usf/product-types';
import { Params } from '@angular/router';

//Due to performance, just show the brands which have more than 50 filter items in the case we search all products.
export const isValidRefinement = (
  searchFilterProperties: string,
  filterNav: SimpleNavigation,
  refinement: SimpleRefinementItem,
) =>
  !searchFilterProperties?.trim().startsWith('0') ||
  filterNav.displayName != 'Brand' ||
  refinement.count >= 50;

export const getExcludeProductNumbersQueryParams = (
  queryParams: Params,
): number[] => {
  if (!!queryParams?.excludeProductNumbers) {
    if (
      typeof queryParams.excludeProductNumbers === 'string' ||
      queryParams.excludeProductNumbers instanceof String
    ) {
      return queryParams.excludeProductNumbers
        .split(',')
        .map(productNumber => +productNumber);
    } else {
      return queryParams.excludeProductNumbers.map(
        productNumber => +productNumber,
      );
    }
  }
  return [];
};
